import React from "react";
import CarouselBg from "./CarouselBg";
import Results from "./Results";

function Testimonial() {
  return (
    <>
      <CarouselBg />
      <Results />
    </>
  );
}

export default Testimonial;
